import classNames from "classnames";
import * as PropTypes from "prop-types";
import CountUp from "react-countup";
import { Motion, spring } from "react-motion";

import inDepthOverlayContentStyles from "./InDepthOverlayContent.css";
import { MOTION_PRESETS } from "/react/constants/motionPresets";

const defaultPropTypes = {
  startContentAnimation: PropTypes.bool,
};

export class InDepthOverlayContentBoxPH extends React.PureComponent {
  static propTypes = defaultPropTypes;

  render() {
    return (
      <InDepthOverlayContentElementPH
        className={inDepthOverlayContentStyles.container}
        {...this.props}
      />
    );
  }
}

export class InDepthOverlayContentRowPH extends React.PureComponent {
  static propTypes = defaultPropTypes;

  render() {
    return (
      <InDepthOverlayContentElementPH
        className={inDepthOverlayContentStyles.row}
        {...this.props}
      />
    );
  }
}

export class InDepthOverlayContentCellPH extends React.PureComponent {
  static propTypes = {
    isHalf: PropTypes.bool,
    isOneThird: PropTypes.bool,
    onAnimationEnd: PropTypes.func,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    ...defaultPropTypes,
  };

  springConfig = MOTION_PRESETS.SMOOTH;

  renderTextWithAnimatedNumbers = (text, startContentAnimation) =>
    text.split(" ").map((word, index) => {
      const spaceBefore = index > 0 ? " " : "";
      const onAnimationEndCallback = this.props.onAnimationEnd;

      if (isNaN(word)) return `${spaceBefore}${word}`;

      const decimals = word.split(".")[1];

      return (
        <CountUp
          decimal="."
          decimals={decimals ? decimals.length : 0}
          duration={1}
          end={word}
          key={index}
          onComplete={onAnimationEndCallback}
          prefix={spaceBefore}
          separator=","
          start={0}
        />
      );
    });

  render() {
    const { isHalf, isOneThird, startContentAnimation, text, title } =
      this.props;

    return (
      <Motion
        defaultStyle={{
          opacity: 0,
        }}
        style={{
          opacity: spring(1, this.springConfig),
        }}
      >
        {(interpolatedStyles) => (
          <div
            className={classNames(inDepthOverlayContentStyles.cell, {
              [inDepthOverlayContentStyles.cellIsHalf]: isHalf,
              [inDepthOverlayContentStyles.cellIsOneThird]: isOneThird,
            })}
            style={{
              opacity: interpolatedStyles.opacity,
            }}
          >
            <p className={inDepthOverlayContentStyles.cellTitle}>{title}</p>
            <p className={inDepthOverlayContentStyles.cellTextPH}>
              {this.renderTextWithAnimatedNumbers(text, true)}
            </p>
          </div>
        )}
      </Motion>
    );
  }
}

const InDepthOverlayContentElementPH = (props) => (
  <div className={props.className}>
    {React.Children.toArray(props.children).map((child, index) =>
      React.cloneElement(child, {
        // startContentAnimation: props.startContentAnimation,
        key: index,
      })
    )}
  </div>
);
